module.exports = __webpack_public_path__ + "static/img/v_7.f5847919.png";